module.exports = __webpack_public_path__ + "img/OurServiceBank_pic1.24c4bd44.png";